import React,{useState} from 'react'

export default function AreaConversion() {
    const [sf, setSf] = useState(0)
    const [sm, setSm] = useState(0)
    const [h, setH] = useState(0)
    const [skm, setSkm] = useState(0)
    const [ac, setA] = useState(0)


    /**Disabling the mouse wheel */
    const inputFields = document.querySelectorAll('.highlight');
    inputFields.forEach(function(inputField) {
            inputField.addEventListener('wheel', function(event) {
            event.preventDefault();
        });
    })
  return (
    <div>
      <div>
        <div style={{display:"flex", justifyContent:"center"}}>
        <h2 style={{color:"#F9D081"}}>Area Conversions</h2>
        </div>
            
        <div   className="grid-container" style={{backgroundColor:"#o44f44d", marginLeft:"25%", marginRight:"25%"}}>
            <div  >
                <div><label id="myLabels" htmlFor="number">Square feet (ft<sup>2</sup>)</label></div>
                
                <input className="highlight" type="number" 
                value={sf}
                onChange={(e) => {
                const a = parseFloat((e.target.value));
                setSf(a);
                setSm(a*0.092903);
                setSkm(a*0.000000092903);
                setH(a*0.0000092903);
                setA(a*0.000022957);
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Square meters (m<sup>2</sup>)</label></div>
                <input className="highlight" type="number"
                value={sm}
                onChange={(e) => {
                    const a = parseFloat((e.target.value));
                    setSf(a*10.7639);
                    setSm(a);
                    setSkm(a*0.000001);
                    setH(a*0.0001);
                    setA(a*0.000247105);
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Square kilometers (km<sup>2</sup>)</label></div>
                <input className="highlight" type="number"
                value={skm}
                onChange={(e) => {
                    const a = parseFloat((e.target.value));
                    setSf(a*10763910.4);
                    setSm(a*1000000);
                    setSkm(a);
                    setH(a*100);
                    setA(a*247.105);
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Hectares (ha)</label></div>
                
                <input className="highlight" type="number" 
                value={h}
                onChange={(e) => {
                    const a = parseFloat((e.target.value));
                    setSf(a*107639.1);
                    setSm(a*10000);
                    setSkm(a*0.01);
                    setH(a);
                    setA(a*2.47105);
            }}/></div>

<div  >
                <div><label id="myLabels" htmlFor="number">Acre (ac)</label></div>
                <input className="highlight" type="number"
                value={ac}
                onChange={(e) => {
                    const a = parseFloat((e.target.value));
                    setSf(a*43560);
                    setSm(a*4046.86);
                    setSkm(a*0.00404686);
                    setH(a*0.404686);
                    setA(a);
            }}/></div>

        

        </div>

    
        </div> 
<div style={{display:"flex", justifyContent:"center"}}>
<button className='clear-button' onClick={(e) => {
        setSf(0);
        setSm(0);
        setSkm(0);
        setH(0);
        setA(0);
    }}>
        Clear Button
    </button>
</div>

    </div>
  )
}
